export function readProfile() {
  try {
    const raw = localStorage.getItem('userProfile');
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function hasRole(profile, role) {
  if (!profile || !role) return false;
  if (Array.isArray(profile.roles) && profile.roles.includes(role)) return true;
  if (Array.isArray(profile.authorities)) {
    return profile.authorities.some(
      (auth) => auth?.authority === role || auth === role,
    );
  }
  return false;
}

export function isPlatformAdmin(profile) {
  return hasRole(profile, 'ROLE_SYSTEM_ADMIN') || hasRole(profile, 'ROLE_ADMIN');
}

export function isSystemAdmin(profile) {
  return hasRole(profile, 'ROLE_SYSTEM_ADMIN');
}
